"use client";

import { useEffect, useState } from 'react';
import { messaging, getToken } from '@/lib/firebase';

export default function FirebaseDebug() {
  const [debugInfo, setDebugInfo] = useState({});

  useEffect(() => {
    const checkFirebase = async () => {
      const info = {
        isClient: typeof window !== 'undefined',
        messaging: !!messaging,
        vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY?.substring(0, 10) + '...',
        apiEndpoint: process.env.NEXT_PUBLIC_API_END_POINT,
        notificationPermission: typeof window !== 'undefined' ? Notification.permission : 'unknown'
      };

      if (messaging) {
        try {
          const token = await getToken(messaging, {
            vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY
          });
          info.tokenGenerated = !!token;
          info.tokenPreview = token?.substring(0, 20) + '...';
        } catch (error) {
          info.tokenError = error.message;
        }
      }

      setDebugInfo(info);
    };

    checkFirebase();
  }, []);

  return (
    <div className="fixed bottom-4 right-4 text-white p-4 rounded text-xs max-w-sm">
      {/* <h3 className="font-bold mb-2">Firebase Debug</h3>
      <pre>{JSON.stringify(debugInfo, null, 2)}</pre> */}
    </div>
  );
}